import { render } from "./SiKaoOneView.vue?vue&type=template&id=01c5b7ff&scoped=true&ts=true"
import script from "./SiKaoOneView.vue?vue&type=script&lang=ts"
export * from "./SiKaoOneView.vue?vue&type=script&lang=ts"

import "./SiKaoOneView.vue?vue&type=style&index=0&id=01c5b7ff&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c5b7ff"]])

export default __exports__